import { render, staticRenderFns } from "./teacherCenter.vue?vue&type=template&id=c2c48470"
import script from "./teacherCenter.vue?vue&type=script&lang=js"
export * from "./teacherCenter.vue?vue&type=script&lang=js"
import style0 from "./teacherCenter.vue?vue&type=style&index=0&id=c2c48470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports